import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { AnalogClock } from '../AnalogClock/AnalogClock';
import styles from './LandingPage.module.scss';
import { TaskWithState, TaskState } from '../../types';

export const HeroSection: React.FC = () => {
  // Static time for the hero visual
  const currentTime = new Date();
  currentTime.setHours(8, 0, 0, 0);

  // Demo task: Breakfast
  const demoTasks: TaskWithState[] = useMemo(() => [
    {
      id: 'demo-1',
      profileId: 'demo',
      label: 'Breakfast',
      icon: '🥣',
      color: '#E09F3E', // Warm Orange (Playful Focus theme)
      start: '07:55',
      end: '08:10',
      startTime: new Date(currentTime.getTime() - 1000 * 60 * 5), // Started 5 mins ago
      endTime: new Date(currentTime.getTime() + 1000 * 60 * 10), // Ends in 10 mins
      duration: 15,
      opacity: 1,
      isCompleted: false,
      state: TaskState.ACTIVE,
      shouldPulse: true
    }
  ], []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section className={styles.heroSection}>
      <h1 className={styles.headline}>
        Stop the Daily Struggle.<br />
        Make Time Visible.
      </h1>
      <p className={styles.subheadline}>
        Turn abstract minutes into colorful wedges your kids can actually see.<br />
        The visual routine builder for ages 3–9.
      </p>
      
      <Link to="/register" className={styles.primaryButton}>
        Start Your Routine Free
      </Link>

      <div className={styles.clockVisual}>
        <AnalogClock
          currentTime={currentTime}
          tasks={demoTasks}
          nextTask={{ task: null, countdownText: '', timeLeft: 0 }}
          onChipClick={() => {}}
          themeId="playful_focus"
          showPastTasks={false}
        />
      </div>
    </section>
  );
};
